//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CustomFieldValueInputItem } from './CustomFieldValueInputItem';

export class ContactFormInputItem extends ItemBase {
    SchoolID: string | null = null;
    WebsiteBlockID: string | null = null;
    CustomFieldValues: CustomFieldValueInputItem[] = [];
    Captcha: string | null = null;

    constructor(initializer?: Partial<ContactFormInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ContactFormInputItem";
}
